"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ReadMore = function ReadMore(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.152 15.776a.469.469 0 01-.344-.148l-1.892-2.04H5.06a1.553 1.553 0 01-1.552-1.552v-6.26c0-.856.696-1.552 1.552-1.552h9.88c.856 0 1.552.696 1.552 1.552v6.256c0 .856-.696 1.552-1.552 1.552h-.688l-1.748 2.028a.46.46 0 01-.344.16c-.004.004-.008.004-.008.004zM5.06 5.16a.616.616 0 00-.616.616v6.256c0 .34.276.616.616.616h5.06c.132 0 .252.052.344.148L12.14 14.6l1.544-1.792a.457.457 0 01.352-.16h.9c.34 0 .616-.276.616-.616V5.776a.616.616 0 00-.616-.616H5.06z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.571 8.46h-6.74a.469.469 0 010-.936h6.74a.469.469 0 010 .936zM13.573 10.132H9.09a.469.469 0 01-.468-.468c0-.26.208-.464.468-.464h4.484c.256 0 .468.208.468.468s-.208.464-.468.464z",
    fill: color
  }));
};
var _default = exports["default"] = ReadMore;